import React, { useState } from "react";
import { Link } from "react-router-dom";
import { GrMenu } from "react-icons/gr";
import { BsXLg } from "react-icons/bs";
import { MdDashboard } from "react-icons/md";
import { MdProductionQuantityLimits } from "react-icons/md";
import { GoBook } from "react-icons/go";
import { FaUsers } from "react-icons/fa";
import { MdOutlineRateReview } from "react-icons/md";
import CreateProductSeller from "../components/Forms/CreateProductSeller";
const DashboarForSeller = () => {
  const [sidebar, setSidebar] = useState("disable");
  const [ableClass, setAbleClass] = useState("opacity-0 nonvisible -left-64");
  const sidebarCall = () => {
    if (sidebar === "disable") {
      setSidebar("able");
      setAbleClass("opacity-1 visible left-0");
    } else {
      setSidebar("disable");
      setAbleClass("opacity-0 nonvisible -left-64");
    }
  };

  return (
    <>
      <div className="w-full py-2.5 h-screen">
        <div className="flex items-center justify-between md:px-8 px-2 py-1">
          <div className="text-3xl mb-3">
            <button onClick={sidebarCall}>
              <GrMenu
                className={`${sidebar === "disable" ? "block" : "hidden"}`}
              />
            </button>
            <button onClick={sidebarCall}>
              <BsXLg
                className={`${
                  sidebar === "disable" ? "hidden" : "block"
                } text-2xl`}
              />
            </button>
          </div>
          <h1 className="text-xl font-bold text-gray-800 ">APNA APP</h1>
        </div>
        <div
          className={`h-full w-72 bg-white z-10 relative ${ableClass}  shadow-2xl px-4  py-8 transition-all duration-300 `}
        >
          <div className="mb-8 group">
            <Link to="/">
              <div className="flex items-center">
                <MdDashboard className="text-lg" />
                <h1 className="ml-2 text-sm font-semibold text-gray-700  group-hover:text-black ">
                  Dashboard
                </h1>
              </div>
            </Link>
          </div>
          <div className="group mb-8">
            <Link to="/">
              <div className="flex items-center">
                <MdProductionQuantityLimits className="text-lg" />
                <h1 className="ml-2 text-sm font-semibold text-gray-700 group-hover:text-gray-900">
                  Products
                </h1>
              </div>
            </Link>
          </div>
          <div className="group mb-8">
            <Link to="/">
              <div className="flex items-center">
                <GoBook className="text-lg" />
                <h1 className="ml-2 text-sm font-semibold text-gray-700 group-hover:text-gray-900">
                  Orders
                </h1>
              </div>
            </Link>
          </div>
          <div className="group mb-8">
            <Link to="/">
              <div className="flex items-center">
                <FaUsers className="text-lg" />
                <h1 className="ml-2 text-sm font-semibold text-gray-700 group-hover:text-gray-900">
                  Users
                </h1>
              </div>
            </Link>
          </div>
          <div className="group mb-8">
            <Link to="/">
              <div className="flex items-center">
                <MdOutlineRateReview className="text-lg" />
                <h1 className="ml-2 text-sm font-semibold text-gray-700 group-hover:text-gray-900">
                  Reviews
                </h1>
              </div>
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute w-full top-24 flex justify-center px-2">
        <div className="md:basis-1/2 w-full">
          <CreateProductSeller />
        </div>
      </div>
    </>
  );
};

export default DashboarForSeller;
